import { createStyles } from 'antd-style'

import { resolveIconColors } from './iconColors'

type Props = {
  color?: string
  shape?: 'round' | 'square'
}

const OFFSET_FACTOR = 6

export const useStyles = createStyles(
  ({ token }, { color, shape = 'round' }: Props = {}) => {
    const { iconColor, backgroundColor } = resolveIconColors(token, color)

    return {
      icon: {
        boxSizing: 'content-box',
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: OFFSET_FACTOR,
        backgroundColor,
        borderRadius: shape === 'square' ? token.borderRadiusLG : '50%',
        color: iconColor,
        lineHeight: 0,

        '& > *': {
          flexShrink: 0
        }
      }
    }
  }
)
